
import { Link } from 'react-router-dom';
import { NavigationMenu, NavigationMenuItem, NavigationMenuList } from "@/components/ui/navigation-menu";
import HelpGuide from './help/HelpGuide';
import GameSettings from './settings/GameSettings';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const isCareerPage = location.pathname === "/careers";
  
  return (
    <header className="w-full border-b border-web3-blue/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center gap-2 transition-transform hover:scale-105">
          <img
            src="/lovable-uploads/3a2f7d01-91cd-43db-b481-05e1b005cd68.png"
            alt="The Blockchain Academy"
            width={371}
            height={64}
            className="h-16 w-auto"
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </Link>

        <div className="flex items-center gap-4">
          {isCareerPage && (
            <div className="flex items-center gap-2">
              <GameSettings 
                trigger={
                  <button className="flex items-center gap-2 bg-background border border-white/20 hover:bg-muted/30 transition-colors rounded-md px-4 py-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-settings h-5 w-5">
                      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span className="font-medium">Settings</span>
                  </button>
                }
              />
              <HelpGuide 
                trigger={
                  <button className="flex items-center gap-2 bg-background border border-white/20 hover:bg-muted/30 transition-colors rounded-md px-4 py-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-help-circle h-5 w-5">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                      <path d="M12 17h.01"></path>
                    </svg>
                    <span className="font-medium">Help</span>
                  </button>
                }
              />
            </div>
          )}

          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <Link 
                  to="/" 
                  className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-web3-blue px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-web3-green hover:text-white focus:bg-web3-green focus:text-white focus:outline-none disabled:pointer-events-none disabled:opacity-50 shadow-md hover:shadow-lg"
                >
                  Home
                </Link>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <Link 
                  to="/careers" 
                  className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-web3-blue px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-web3-green hover:text-white focus:bg-web3-green focus:text-white focus:outline-none disabled:pointer-events-none disabled:opacity-50 shadow-md hover:shadow-lg"
                >
                  Career Paths
                </Link>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>
      </div>
    </header>
  );
};

export default Header;
